<template>
<div>
    <div class="box-header">
      <h3 class="box-title title">Inventario</h3>
    </div>
  <div class="box box-success">
       <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img class="icon-space" src='/static/img/icons/search.png' style="padding-bottom:7px"> Buscar Inventario</h3>
    </div>
    <div class="box-body">
      <div class="filterContainer">
        <div class="row">
          <div class="col-md-4 divAccountSelectInventory">
            <div id="divAccountSelect" class="form-group">
              <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
                <span slot="noResult">
                  No se encontraron resultados
                </span>
              </multiselect>
            </div>
          </div>
          <div class="col-md-2 form-interspace">
            <div class="form-group">  
              <label for="ddlYear">Año</label>  
              <select id="ddlYear" v-model="selectedYear" class="form-control minimal" @change="loadTableData()">
                <option v-for="year in this.optionsYear" v-bind:key="year" v-bind:value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2 form-interspace">
            <div class="form-group">  
              <label for="ddlMonth">Mes</label>  
              <select id="ddlMonth" v-model="selectedMonth" class="form-control minimal" @change="loadTableData()">
                <option v-for="month in this.optionsMonth" v-bind:key="month.value" v-bind:value="month.value">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-interspace">
            <div class="form-group pull-left" style="padding-top:25px;">
              <router-link :to="{name: 'InventoryEntry', params: {period: (this.selectedYear + '' + this.selectedMonth), accountCode: this.selectedAccount.code} }" tag="button" class="btn btn-success">Registrar ERI</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <br/>
        </div>
      </div>
      <div class="row">
        <div id="clientTable" class="col-md-12">
          <vuetable 
            id="clientTable"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :data="tableData"
            :sort-order="tableSortOrder"
            :css="tableCSS.table"
            @vuetable:row-clicked="onClick"
            @vuetable:loading="onLoading"        
            @vuetable:loaded="onLoaded"
            noDataTemplate="No se encontraron resultados"
          >
           <div id="Cliente" slot="accountCode" slot-scope="props">
                <span >{{props.rowData.accountCode}}</span>
            </div>

             <div id="Eri Cíclico" slot="cyclicalPercentage" slot-scope="props">
                <span >{{props.rowData.cyclicalPercentage}}</span>
            </div>

             <div id="Eri Ubicación" slot="locationPercentage" slot-scope="props">
                <span >{{props.rowData.locationPercentage}}</span>
            </div>

             <div id="Eri Unidad" slot="unitPercentage" slot-scope="props">
                <span >{{props.rowData.unitPercentage}}</span>
            </div>
          </vuetable>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vuetable from 'vuetable-2'
import constants from 'assets/js/constants.js'
import util from 'assets/js/util.js'

export default {
  name: 'Inventory',
  components: {
    Multiselect,
    Vuetable
  },
  data () {
    return {
      loader: null,
      optionsAccount: null,
      selectedAccount: null,
      optionsYear: [],
      selectedYear: null,
      optionsMonth: [],
      selectedMonth: null,
      tableData: null,
      tableFields: [
        {
          name: '__slot:accountCode',
          title: 'Cliente',
          callback: 'formatClient'
        },
        {
          name: '__slot:cyclicalPercentage',
          title: 'Eri Cíclico',
          callback: 'formatPercentage'
        },
        {
          name: '__slot:locationPercentage',
          title: 'Eri Ubicación',
          callback: 'formatPercentage'
        },
        {
          name: '__slot:unitPercentage',
          title: 'Eri Unidad',
          callback: 'formatPercentage'
        }
      ],
      tableSortOrder: [
        { field: 'name', direction: 'asc' }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        }
      },
      tableOptions: {
        headings: {
          clientName: 'Cliente',
          eriCyclical: 'Eri Cíclico',
          eriLocation: 'Eri Ubicación',
          eriUnit: 'Eri Unidad'
        },
        filterable: false,
        sortable: ['clientName'],
        texts: {
          count: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  created () {
    this.loadSelectData()
    this.loadTableData()
  },
  methods: {
    ...mapActions([
      'fetchEriSummaryData'
    ]),
    loadSelectData () {
      // Client
      this.optionsAccount = Array.from(this.userClients)
      this.optionsAccount.unshift(constants.defaultSelectItem)
      this.selectedAccount = this.optionsAccount[0]

      // Year
      let yearObj = util.getYearList(2010)

      this.optionsYear = yearObj.list
      this.selectedYear = yearObj.current

      // Month
      let monthObj = util.getMonthList()

      this.optionsMonth = monthObj.list
      this.selectedMonth = monthObj.current.value
    },
    loadTableData () {
      let code = this.selectedAccount.code

      let params = {
        AccountCodes: [],
        Period: (this.selectedYear + '' + this.selectedMonth)
      }

      if (code === 'All') {
        for (let index = 1; index < this.optionsAccount.length; index++) {
          params.AccountCodes.push(this.optionsAccount[index].code)
        }
      } else {
        params.AccountCodes.push(code)
      }

      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchEriSummaryData(params)
      .then((data) => {
        if (data != null) {
          let tableData = {
            period: this.selectedYear + '' + this.selectedMonth,
            data: data
          }

          this.tableData = tableData
          this.loader.hide()
        }
      })
    },
    /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedAccount = account
      this.loadTableData()
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
    },
    formatClient (value) {
      return this.userClients.filter(item => item.code === value)[0].name
    },
    formatPercentage (value) {
      return this.$options.filters.formatPercentage(value) + '%'
    },
    onClick (row) {
      this.$router.push({ name: 'InventoryDetail', params: { accountCode: row.accountCode, period: this.tableData.period } })
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

#clientTable tbody tr {
  cursor: pointer;
}

.divAccountSelectInventory{
  width: 18% !important;
}

@media screen and (max-width: 1330px) {
  .divAccountSelectInventory{
    width: 20% !important;
  }
}

@media screen and (max-width: 1150px) {
  .divAccountSelectInventory{
    width: 25% !important;
    padding-bottom: 10px;
  }
}

@media screen and (max-width: 990px) {
  .divAccountSelectInventory{
    width: 100% !important;
  }
}


@media screen and (max-width: 600px) {

  #documentTypeCode td{
    padding-left: 50%  !important
  }

   #clientTable table {
      border: 0;
    }

   #clientTable thead {
      display: none;
    }

   #clientTable table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
	    border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #clientTable table td {
      display: block;
      border: none !important;
      font-size: 13px;
      text-align: right;
      
    }

   #clientTable table td:last-child {
      border-bottom: 0;
    }

    #clientTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#clientTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

  }

</style>



// WEBPACK FOOTER //
// Inventory.vue?e9da058c